import { html, nothing } from 'lit';
import { repeat } from 'lit/directives/repeat.js'; // Додано для віртуалізації/оптимізації
import { _converse, api, converse, u, constants } from '@converse/headless';
import { getChatStyle, getUnreadMsgsDisplay } from 'shared/chat/utils.js';
import { debounce } from 'lodash'; // или простая реализация
import { __ } from 'i18n';

const { Strophe } = converse.env;
let initialized = false;

// Підсвічуємо в списку чат, який зараз відкритий у панелі — тим самим
// кольором, що й hover (.list-item.open, див. 02-resizer.css), щоб було
// видно, з ким зараз листування, без ефекту наведення миші.
const isCurrentlyOpen = (jid) => {
    if (!u.isUniView()) return false;
    const chatbox = _converse.chatboxes.get(jid);
    return !!chatbox && !chatbox.get('hidden');
};

/**
 * @param {import('../controlbox').default} el
 */

function whenNotConnected(el) {
    const connection_status = _converse.state.connfeedback.get('connection_status');
    const connecting = [Strophe.Status.RECONNECTING, Strophe.Status.CONNECTING, Strophe.Status.CONNECTED].includes(
        connection_status,
    );
    const is_fullscreen = api.settings.get('view_mode') === 'fullscreen';

    return html`<converse-controlbox-buttons class="controlbox-padded"></converse-controlbox-buttons><div class="controlbox-pane d-flex flex-column justify-content-between">${connecting
                ? html`<converse-spinner class="vertically-centered"></converse-spinner>`
                : html`<converse-brand-logo></converse-brand-logo><converse-login-form class="fade-in rounded"></converse-login-form>`}</div>`;
}

export default (el) => {
    const isConnected = el.model.get('connected');

    if (isConnected && !initialized) {
        // Switching the open chat toggles `hidden` on two models in a row
        // (chatbox.js's maybeShow() hides the previously-open chat, then
        // shows the new one) -- each is its own 'change:hidden' event below,
        // so a single switch was re-running this whole sidebar's contact/room
        // list computation (allContacts/allRooms/activeChats, each with its
        // own per-chat getLastMsgTime/getLastMsgText/getUnreadCount passes)
        // twice. Debouncing collapses bursts like that into one render.
        const update = debounce(() => el.requestUpdate(), 50);
        el.model.set('active_tab', 'all');
        // Показ стилізованого попапа про новий запит на контакт + кнопка переходу
        // у "Мої категорії → Запити на контакт".
        const showContactRequestPopup = (name) => {
            document.getElementById('sonata-req-popup')?.remove();
            const wrap = document.createElement('div');
            wrap.id = 'sonata-req-popup';
            wrap.style.cssText =
                'position:fixed; top:70px; right:20px; z-index:100000; width:320px; max-width:90vw;' +
                'background:#16314d; color:#e8f0ff; border:1px solid rgba(154,185,255,.25);' +
                'border-radius:10px; box-shadow:0 6px 24px rgba(0,0,0,.4); padding:16px;';
            wrap.innerHTML =
                '<div style="font-weight:600; font-size:15px; margin-bottom:6px;">Новий запит на контакт</div>' +
                '<div style="font-size:14px; color:#cfe0ff; margin-bottom:14px; line-height:1.4;">' +
                'Користувач <b id="sonata-req-name" style="color:#fff;"></b> хоче додати вас до контактів.</div>' +
                '<div style="display:flex; gap:8px; justify-content:flex-end;">' +
                '<button id="sonata-req-dismiss" style="padding:8px 12px; border:none; border-radius:6px;' +
                'background:rgba(255,255,255,.1); color:#e8f0ff; cursor:pointer;">Пізніше</button>' +
                '<button id="sonata-req-open" style="padding:8px 12px; border:none; border-radius:6px;' +
                'background:#1e9652; color:#fff; cursor:pointer;">Переглянути запити</button></div>';
            wrap.querySelector('#sonata-req-name').textContent = name; // безпечно (без XSS)
            document.body.appendChild(wrap);

            const close = () => wrap.remove();
            wrap.querySelector('#sonata-req-dismiss').onclick = close;
            wrap.querySelector('#sonata-req-open').onclick = () => {
                el.model.set('active_tab', 'contacts'); // вкладка "Мої категорії"
                const rs = _converse.state.roster.state;
                const collapsed = (rs.get('collapsed_groups') || []).filter((g) => g !== __('Запити на контакт'));
                rs.save({ collapsed_groups: collapsed }); // розгортаємо групу запитів
                el.requestUpdate();
                close();
            };
            setTimeout(close, 15000); // авто-закриття
        };

        _converse.api.listen.on('contactRequest', (contact) => {
            const jid = contact.get('jid');
            const name = contact.get('fullname') || contact.get('nickname') || jid.split('@')[0];
            update();
            showContactRequestPopup(name);
        });
        // Підписуємося тільки якщо об'єкти існують
        _converse.api.listen.on('message', (data) => {
            const stanza = data.stanza;
            // Если в XML сообщения нет <body>, это скорее всего техническое сообщение (chatstate, receipt, ping)
            // Мы не хотим вызывать тяжелый update() для всего списка чатов на такие события
            if (stanza.getElementsByTagName('body').length > 0) {
                update();
            }
        });

        // _converse.api.waitUntil('chatBoxesFetched').then(() => {
        //         console.log("Chatboxes are fetched and ready. Binding listeners...");

        //                 console.log(`[Chatbox Update]: ${event}`);
        //                 update(); // Ваша функция el.requestUpdate()

        //     });

        if (_converse.chatboxes) {
            _converse.chatboxes.on('all', (event, model) => {
                // 1. Фильтруем шум (vcard, изменения отдельных полей, которые не влияют на список)
                if (!event || event.includes('vcard') || event.includes('change:chat_status')) return;
                if (!model?.get) return;

                // 2. Логика автоматического прочтения (для открытого чата)
                // Проверяем, что чат стал видимым ИЛИ пришло новое сообщение в уже видимый чат
                // const isVisible = model.get('hidden') === false;
                // const hasUnread = (model.get('num_unread') || 0) > 0;

                // if (isVisible && hasUnread) {
                //     // Вместо setTimeout используем requestAnimationFrame или короткий debounce,
                //     // чтобы дать модели завершить текущие расчеты
                //     requestAnimationFrame(() => {
                //         // Важно: проверяем статус еще раз внутри кадра анимации
                //         if (model.get('hidden') === false && model.get('num_unread') > 0) {
                //             console.debug(`=== SONATA: Marking as read ${model.get('jid')} ===`);

                //             // Штатный метод Converse для пометки прочитанным.
                //             // Он сам очистит num_unread, num_unread_general и отправит чек прочтения.
                //             if (typeof model.markRead === 'function') {
                //                 model.markRead();
                //             } else {
                //                 // Фолбэк, если метод почему-то недоступен
                //                 model.save(
                //                     {
                //                         'num_unread': 0,
                //                         'num_unread_general': 0,
                //                         'first_unread_id': null,
                //                     },
                //                     { silent: true },
                //                 );
                //             }
                //             update();
                //         }
                //     });
                //     return;
                // }

                // 3. Обработка других важных ивентов для обновления UI
                // Добавляем 'destroy' и 'reset' для корректной очистки списка
                const criticalEvents = [
                    'add',
                    'remove',
                    'destroy',
                    'reset',
                    'sync',
                    'change:num_unread',
                    'change:hidden',
                    'change:active_tab',
                    'change:muted',
                    'change:pinned',
                ];

                if (criticalEvents.some((e) => event === e || event.startsWith(e + ':'))) {
                    update();
                }
            });
        }

        // if (_converse.chatboxes) {
        //     _converse.chatboxes.on('all', (event, model) => {
        //         if (!event || event.includes('vcard')) return;
        //         if (!model?.get) return;

        //         const isVisible = model.get('hidden') === false;
        //         const hasUnread = (model.get('num_unread') || 0) > 0;

        //         // Якщо чат відкритий і є непрочитані
        //         if (isVisible && hasUnread) {
        //             // Використовуємо таймаут, щоб дати Converse час показати нотифікацію
        //             // перед тим, як ми обнулимо стан моделі.
        //             setTimeout(() => {
        //                 // Ще раз перевіряємо, чи чат все ще видимий (щоб не скинути випадково)
        //                 if (model.get('hidden') === false && model.get('num_unread') > 0) {
        //                     console.log(`=== SONATA: Async clearing for ${model.get('jid')} ===`);

        //                     model.save(
        //                         {
        //                             'num_unread': 0,
        //                             'num_unread_general': 0,
        //                             'first_unread_id': null,
        //                         },
        //                         { silent: true },
        //                     ); // silent: true, щоб не зациклити подію 'all'

        //                     update();
        //                 }
        //             }, 100); // 100мс достатньо для спрацювання нотифікацій
        //             return;
        //         }

        //         const updateEvents = ['change:num_unread', 'add', 'remove', 'sync', 'change'];
        //         if (updateEvents.some((e) => event === e || event.includes(e))) {
        //             update();
        //         }
        //     });
        // }
        // if (_converse.chatboxes) {
        //     _converse.chatboxes.on('all', (event, model) => {
        //         console.log(event, model);
        //         if (event && event.includes('change:active_tab')) {
        //             update();
        //         }
        //         if (event === 'show') {
        //         }
        //         if (event && event.includes('sync')) {
        //             update();
        //         }
        //         if (event.includes('change:hidden')) {
        //             const isHidden = model.get('hidden');
        //             // Якщо hidden став false (чат відкрився) або undefined (що теж означає видимість)
        //             if (isHidden === false) {
        //                 console.log(`=== SONATA: Chat opened for ${model.get('jid')}, clearing unread ===`);

        //                 model.save({
        //                     'num_unread': 0,
        //                     'num_unread_general': 0,
        //                     'first_unread_id': null,
        //                 });
        //                 update();
        //             }
        //         }
        //         if ((event && event.includes('change:state')) || (event && event === 'change')) {
        //             console.log('Chatbox state changed, checking if update is needed...');
        //             console.log(model, model.get('jid'), model.get('num_unread'));
        //             return;
        //         }
        //         // if (event && event.includes('change')) update();
        //         if (event.includes('change:num_unread')) {
        //             console.log('Unread count changed for:', model.get('jid'), model.get('num_unread'));
        //             update();
        //         }
        //     });
        //     _converse.chatboxes.on('add remove', update);
        // }

        //         if (_converse.state.roster) {
        //     // Стандартні оновлення
        //     // _converse.state.roster.on('add remove change', update);

        //     // _converse.api.listen.on('rosterGroupsFetched', () => {
        //     //     console.log("Roster groups fully synced from server");
        //     //     update();
        //     // });
        //         if (_converse.state.roster) {
        //     // Стандартні оновлення
        //     // _converse.state.roster.on('add remove change', update);

        //     // _converse.api.listen.on('rosterGroupsFetched', () => {
        //     //     console.log("Roster groups fully synced from server");
        //     //     update();
        //     // });
        // }

        if (_converse.bookmarks) {
            _converse.bookmarks.on('add remove reset', update);
        }

        // if (_converse.state.roster) {
        //     _converse.state.roster.on('add remove change', update);
        // }

        initialized = true;
    }

    // Якщо не підключені — скидаємо статус ініціалізації
    if (!isConnected) {
        initialized = false;
        return whenNotConnected(el);
    }

    const view_mode = el.model.get('view_mode') || 'default';
    const style = getChatStyle(el.model);
    const filter_text = (el.model.get('filter_text') || '').toLowerCase();
    const active_tab = el.model.get('active_tab') || 'all';

    const formatMsgTime = (timestamp) => {
        if (!timestamp || timestamp === 0) return '';

        const date = new Date(timestamp);
        const now = new Date();

        // Проверка, является ли дата сегодняшней
        const isToday =
            date.getDate() === now.getDate() &&
            date.getMonth() === now.getMonth() &&
            date.getFullYear() === now.getFullYear();

        if (isToday) {
            // Формат HH:MM (добавляем ведущий ноль, если нужно)
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        } else {
            // Формат DD.MM
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            return `${day}.${month}`;
        }
    };

    const getLastMessageObj = (jid) => {
        const chatbox = _converse.chatboxes.get(jid);
        if (!chatbox || !chatbox.messages || chatbox.messages.length === 0) return null;

        // Расширенная фильтрация:
        const realMessages = chatbox.messages.filter((m) => {
            const isInfo = m.get('type') === 'info';
            const hasBody = !!(m.get('body') || m.get('message') || m.get('plaintext'));

            // Фильтруем Chat States (composing, paused, etc) и пустые сообщения
            // Converse обычно помечает сообщения с chatstates, но без body как не имеющие текста.
            // Также исключаем сообщения, которые являются только подтверждениями доставки или пингами.
            const isChatStateOnly = !hasBody && (m.get('chat_state') || m.get('is_ack'));

            return !isInfo && hasBody && !isChatStateOnly;
        });

        return realMessages.length > 0 ? realMessages[realMessages.length - 1] : null;
    };

    const closeRoom = async (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        const target = /** @type {HTMLElement} */ (ev.currentTarget);
        const jid = target.getAttribute('data-room-jid');
        const name = target.getAttribute('data-room-name');

        // Відрізаємо домен для REST API
        const roomNode = jid ? jid.split('@')[0] : '';

        const domain = localStorage.getItem('s_selected_domain');
        const apiRoot = `https://api-admin-chat.${domain}/chat-room/leave`;

        if (!(await api.confirm(__('Confirm'), __('Ви впевнені, що хочете покинути %1$s?', name)))) return;

        try {
            const token = sessionStorage.getItem('s_token');

            // 1. Виклик REST API (працює з roomNode)
            const response = await fetch(apiRoot, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ room: roomNode }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'REST API Error');
            }

            // 2. Видалення закладки через внутрішній стан Converse (як у тестах)
            // Це змусить Converse відправити <retract> на XMPP сервер
            if (_converse.state.bookmarks) {
                const bookmark = _converse.state.bookmarks.findWhere({ jid: jid });
                if (bookmark) {
                    _converse.state.bookmarks.remove(bookmark);
                }
            }

            // 3. Очищення самої кімнати в інтерфейсі
            const room = await _converse.api.rooms.get(jid);
            if (room) {
                // Спочатку виходимо (presence unavailable)
                await room.leave();
                // Потім знищуємо об'єкт (видалення з DOM та пам'яті)
                room.destroy();
            }
        } catch (e) {
            console.error('Full leave failed:', e);
            alert(`Помилка: ${e.message}`);
        }
    };

    // const hasMessages = (jid) => {
    //     const chatbox = _converse.chatboxes.get(jid);
    //     return chatbox && chatbox.messages && chatbox.messages.length > 0;
    // };

    const hasMessages = (jid) => {
        const chatbox = _converse.chatboxes.get(jid);
        if (!chatbox || !chatbox.messages) return false;

        return chatbox.messages.models.some((m) => {
            const hasBody = !!(m.get('body') || m.get('plaintext') || m.get('message'));
            const isInfo = m.get('type') === 'info';
            return hasBody && !isInfo;
        });
    };

    // const isTargetRoom = (jid) => jid.includes('opulugoz');

    const getLastMsgText = (jid) => {
        const msg = getLastMessageObj(jid);

        if (!msg) return '';

        // Берем текст из разных возможных полей
        const rawText = msg.get('plaintext') || msg.get('body') || msg.get('message') || '';

        // Если сообщение системное (info), возвращаем его как есть, но серым цветом (через CSS)
        if (msg.get('type') === 'info') return rawText;

        // Очистка от /me
        const cleanText = rawText.replace(/^\/me\s+/, '').trim();

        // ОПРЕДЕЛЕНИЕ АВТОРА (для групп)
        // В ваших логах видно поле 'nick', используем его
        let sender = msg.get('nick') || '';

        // Если ник слишком длинный (как "Test1 android ДжумікБогдана"), берем первое слово
        if (sender.includes(' ')) {
            sender = sender.split(' ')[0];
        }

        const prefix = sender && jid.includes('@conference') ? `${sender}: ` : '';
        const finalResult = cleanText;

        const MAX_LENGTH = 45;

        if (finalResult.length > MAX_LENGTH) {
            return finalResult.substring(0, MAX_LENGTH - 3) + '...';
        }
        return finalResult;

        //return finalResult.length > 35 ? finalResult.substring(0, 32) + "..." : finalResult;
    };
    const getLastMsgTime = (jid) => {
        if (!jid) return 0;
        const chatbox = _converse.chatboxes.get(jid);
        if (!chatbox) return 0;

        const messages = chatbox.messages?.models || [];
        const lastRealMsg = [...messages]
            .reverse()
            .find((m) => m.get('type') !== 'info' && (m.get('body') || m.get('plaintext')));

        if (lastRealMsg) {
            const time = lastRealMsg.get('time');
            return time ? new Date(time).getTime() : 0;
        }

        // ВАЖНО: Если сообщений нет, возвращаем 0.
        // Не используем время создания чатбокса для вкладки "Усі чати"
        return 0;
    };
    // const getLastMsgTime = (jid) => {
    //     if (!jid) return 0;
    //     const chatbox = _converse.chatboxes.get(jid);
    //     if (!chatbox) return 0;

    //     const messages = chatbox.messages?.models || [];
    //     // Ищем последнее реальное сообщение
    //     const lastRealMsg = [...messages].reverse().find(m =>
    //         m.get('type') !== 'info' && (m.get('body') || m.get('plaintext'))
    //     );

    //     if (lastRealMsg) {
    //         const time = lastRealMsg.get('time');
    //         return time ? new Date(time).getTime() : 0;
    //     }

    //     console.warn(messages,chatbox, lastRealMsg,chatbox.get('time') )

    //     // ВАЖНО: Если сообщений нет, используем время создания чатбокса или очень старую дату,
    //     // чтобы порядок был стабильным, а не случайным.
    //     return chatbox.get('time') ? new Date(chatbox.get('time')).getTime() : 1;
    // };

    //     const getLastMsgTime = (jid) => {
    //         if (!jid) return 0;
    //     const chatbox = _converse.chatboxes.get(jid);
    //     if (!chatbox) return 0;
    //  console.log(jid, chatbox);
    //     // 1. Пріоритет: останнє повідомлення (реальна активність)
    //     const last_msg = chatbox.messages?.last();
    //     if (last_msg) {
    //         const time = last_msg.get('time');
    //         if (time) return new Date(time).getTime();
    //     }

    //     const attr_time = chatbox.get('time');
    //     if (attr_time) {
    //         const timeMs = new Date(attr_time).getTime();

    //         return timeMs;
    //     }

    //     return 0;
    // };
    const REQUESTS_LABEL = __('Запити на контакт');

    const getGroupedContacts = () => {
        const roster = _converse.state.roster;
        console.log('[Roster Debug] getGroupedContacts triggered. Roster size:', roster?.models?.length);
        console.log(roster);
        if (!roster || !roster.models.length) {
            console.warn('[Roster Debug] Roster is empty or not initialized');
            return [];
        }

        const groups = {};
        const UNGROUPED_LABEL = __('Ungrouped');

        const selfJids = new Set(
            [
                _converse.session?.get('bare_jid'),
                _converse.bare_jid,
                _converse.jid,
                typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('s_jid') : null,
            ]
                .filter(Boolean)
                .map((j) => j.split('/')[0].toLowerCase()),
        );

        // "Запит на контакт" = НЕпідтверджений контакт (subscription НЕ 'both' і НЕ 'to'),
        // для якого є ознака взаємодії: вхідний запит (requesting), вихідний очікуваний
        // (ask='subscribe'), або незбережений без груп, з яким уже є листування (hasMessages).
        // Власний JID і вже підтверджені контакти сюди НЕ потрапляють.
        const isPendingRequest = (contact) => {
            const jid = (contact.get('jid') || '').toLowerCase();
            if (!jid || selfJids.has(jid) || jid.includes('@conference.')) return false;
            if (contact.get('confirmed')) return false; // вже підтверджений вручну → у звичайні групи
            const sub = contact.get('subscription');
            if (sub === 'both' || sub === 'to') return false;
            if (contact.get('requesting') === true) return true;
            // Вихідний запит (ТИ додав контакт → ask='subscribe', очікуєш підтвердження)
            // — це НЕ "запит на контакт", а твій контакт. Хай живе у звичайних групах /
            // Негруповані, а не у "Запити на контакт". Тому явно виходимо тут (також щоб
            // не потрапити нижче у hasMessages-евристику).
            if (contact.get('ask') === 'subscribe') return false;
            const cGroups = contact.get('groups') || [];
            if ((!sub || sub === 'none') && cGroups.length === 0 && hasMessages(jid)) return true;
            return false;
        };

        roster.models.forEach((contact) => {
            // MUC-кімнати іноді потрапляють у ростер (стара пошкоджена підписка,
            // синхронізація з сервера тощо) — вони не контакти, показуємо їх лише
            // у "Групи"/"Усі чати" через allRooms, як і робить allContacts вище.
            if ((contact.get('jid') || '').includes('@conference.')) return;

            // Запити на контакт — в окрему групу зверху (з кнопками прийняти/відхилити / додати).
            if (isPendingRequest(contact)) {
                if (!groups[REQUESTS_LABEL]) {
                    groups[REQUESTS_LABEL] = { name: REQUESTS_LABEL, contacts: [] };
                }
                groups[REQUESTS_LABEL].contacts.push(contact);
                return;
            }

            let cGroups = contact.get('groups') || [];

            if (cGroups.length === 0) {
                cGroups = [UNGROUPED_LABEL];
            }

            cGroups.forEach((groupName) => {
                if (!groups[groupName]) {
                    groups[groupName] = { name: groupName, contacts: [] };
                }
                groups[groupName].contacts.push(contact);
            });
        });

        // Порядок: звичайні групи (за алфавітом) → "Негруповані" → "Запити на контакт" (в самому низу).
        const rank = (name) => (name === REQUESTS_LABEL ? 2 : name === UNGROUPED_LABEL ? 1 : 0);
        const result = Object.values(groups).sort((a, b) => {
            const ra = rank(a.name);
            const rb = rank(b.name);
            if (ra !== rb) return ra - rb;
            return a.name.localeCompare(b.name);
        });

        console.log(
            '[Roster Debug] Final Groups Map:',
            result.map((g) => `${g.name} (${g.contacts.length})`),
        );
        return result;
    };

    const renderAlphabeticalContacts = () => {
        const contacts = allContacts || [];
        const grouped = contacts.reduce((groups, contact) => {
            // Додаємо fallback-значення, щоб уникнути помилок з порожніми рядками
            const name = (contact.get('fullname') || contact.get('jid') || 'Unknown').trim();
            const letter = name[0] ? name[0].toUpperCase() : '#';

            if (!groups[letter]) groups[letter] = [];
            groups[letter].push(contact);
            return groups;
        }, {});

        const sortedLetters = Object.keys(grouped).sort();

        return html`<div class="new-chat-list"><div class="new-contact-actions"><div class="list-item-action" @click="${(ev) => api.modal.show('converse-add-muc-modal', { 'model': el.model }, ev)}" data-toggle="modal" data-target="#add-chatrooms-modal"><i class="icon-group"><svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.8891 17.2655C13.8891 16.3998 13.8888 15.7873 13.8557 15.3058C13.823 14.8309 13.7604 14.5371 13.6631 14.304C13.3624 13.584 12.7858 13.0122 12.0599 12.7139C11.8248 12.6173 11.5286 12.5553 11.0498 12.5229C10.5644 12.49 9.94685 12.4897 9.07406 12.4897H6.29623C5.42344 12.4897 4.80586 12.49 4.32046 12.5229C3.84166 12.5553 3.54545 12.6173 3.31043 12.7139C2.58451 13.0122 2.00793 13.584 1.70721 14.304C1.60986 14.5371 1.54727 14.8309 1.5146 15.3058C1.48151 15.7873 1.48115 16.3998 1.48115 17.2655C1.48115 17.6712 1.14968 18 0.740573 18C0.331466 18 6.57663e-08 17.6712 6.57663e-08 17.2655C6.57663e-08 16.4197 -0.000287018 15.7485 0.0370739 15.2054C0.0748915 14.6557 0.153612 14.1837 0.338186 13.7417C0.789277 12.6616 1.65447 11.8035 2.74347 11.3561C3.18907 11.173 3.665 11.0949 4.21919 11.0574C4.76677 11.0203 5.44349 11.0206 6.29623 11.0206H9.07406C9.92679 11.0206 10.6035 11.0203 11.1511 11.0574C11.7053 11.0949 12.1812 11.173 12.6268 11.3561C13.7158 11.8035 14.581 12.6616 15.0321 13.7417C15.2167 14.1837 15.2954 14.6557 15.3332 15.2054C15.3706 15.7485 15.3703 16.4197 15.3703 17.2655C15.3703 17.6712 15.0388 18 14.6297 18C14.2206 18 13.8891 17.6712 13.8891 17.2655ZM18.5189 17.2655V15.4287C18.5189 14.0604 17.5752 12.9084 16.2971 12.5821C15.901 12.4809 15.6626 12.0808 15.7645 11.6879C15.8665 11.295 16.2699 11.0586 16.6661 11.1596C18.5829 11.649 20 13.3736 20 15.4287V17.2655C20 17.6712 19.6685 18 19.2594 18C18.8503 18 18.5189 17.6712 18.5189 17.2655ZM10.6483 4.40807C10.6483 2.785 9.32157 1.46906 7.68514 1.46906C6.04871 1.46906 4.72195 2.785 4.72195 4.40807C4.72195 6.03114 6.04871 7.34708 7.68514 7.34708C9.32157 7.34708 10.6483 6.03114 10.6483 4.40807ZM14.8151 4.40807C14.8151 3.17598 14.0503 2.11909 12.9632 1.68251C12.584 1.53026 12.401 1.10168 12.5545 0.725561C12.7081 0.349838 13.1394 0.16828 13.5184 0.320179C15.1459 0.973582 16.2962 2.55689 16.2962 4.40807C16.2962 6.25925 15.1459 7.84256 13.5184 8.49596C13.1394 8.64786 12.7081 8.46631 12.5545 8.09058C12.401 7.71446 12.584 7.28588 12.9632 7.13363C14.0503 6.69705 14.8151 5.64016 14.8151 4.40807ZM12.1295 4.40807C12.1295 6.84268 10.1398 8.81614 7.68514 8.81614C5.2305 8.81614 3.2408 6.84268 3.2408 4.40807C3.2408 1.97346 5.2305 0 7.68514 0C10.1398 0 12.1295 1.97346 12.1295 4.40807Z" fill="#9AB9FF"/></svg> </i><span>Нова група</span></div><div class="list-item-action" @click="${(/** @type {MouseEvent} */ ev) => el.showAddContactModal(ev)}"><i class="icon-user-plus"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.3942 21.2133V17.9668H13.1485C12.7143 17.9668 12.3619 17.6152 12.3619 17.1809C12.3619 16.7466 12.7143 16.3942 13.1485 16.3942H16.3942V13.1485C16.3942 12.7143 16.7466 12.3619 17.1809 12.3619C17.6152 12.3619 17.9668 12.7143 17.9668 13.1485V16.3942H21.2133C21.6476 16.3942 22 16.7466 22 17.1809C21.9999 17.6152 21.6476 17.9668 21.2133 17.9668H17.9668V21.2133C17.9668 21.6476 17.6152 21.9999 17.1809 22C16.7466 22 16.3942 21.6476 16.3942 21.2133Z" fill="#9AB9FF"/><path d="M2.00006 19.84C2.00006 18.5709 1.99108 17.7679 2.19853 17.0942C2.64679 15.6385 3.80341 14.499 5.28105 14.0574C5.96492 13.853 6.78001 13.8618 8.06819 13.8618H10.4979C10.9235 13.8618 11.2683 14.2015 11.2683 14.6208C11.2683 15.0401 10.9235 15.3798 10.4979 15.3798H8.06819C6.66818 15.3798 6.13872 15.388 5.7288 15.5105C4.74368 15.8049 3.97231 16.5648 3.67347 17.5353C3.54919 17.9392 3.54084 18.4608 3.54084 19.84C3.54084 20.2593 3.19603 20.599 2.77045 20.599C2.34487 20.599 2.00006 20.2593 2.00006 19.84ZM14.0404 7.02924C14.0404 5.09011 12.4446 3.51795 10.4763 3.51795C8.50795 3.51795 6.91213 5.09011 6.91213 7.02924C6.91213 8.96837 8.50795 10.5405 10.4763 10.5405C12.4446 10.5405 14.0404 8.96837 14.0404 7.02924ZM15.5812 7.02924C15.5812 9.80691 13.2957 12.0585 10.4763 12.0585C7.65679 12.0585 5.37135 9.80691 5.37135 7.02924C5.37135 4.25156 7.65679 2 10.4763 2C13.2957 2 15.5812 4.25156 15.5812 7.02924Z" fill="#9AB9FF"/></svg> </i><span>Новий контакт</span></div></div>${sortedLetters.map(
                    (letter) => html`<div class="alphabet-separator">${letter}</div><ul class="items-list">${[...grouped[letter]] // Копіюємо масив перед сортуванням!
                                .sort((a, b) => {
                                    const nameA = a.get('fullname') || a.get('jid') || '';
                                    const nameB = b.get('fullname') || b.get('jid') || '';
                                    return nameA.localeCompare(nameB);
                                })
                                .map((c) => renderRosterContact(c))}</ul>`,
                )}</div>`;
    };

    // Рядок для групи "Запити на контакт": аватар + ім'я + кнопки Підтвердити / Відхилити.
    // Кнопки викликають штатні методи моделі контакту, які шлють відповідні XMPP-станзи:
    //   authorize()  -> <presence type="subscribed">    (підтвердити вхідний запит)
    //   subscribe()  -> <presence type="subscribe">     (підписатися у відповідь / додати)
    //   unauthorize()-> <presence type="unsubscribed">  (відхилити)
    //   remove(true) -> unsubscribe + видалення з ростера на сервері
    const renderRequestContact = (contact) => {
        const jid = contact.get('jid');
        const name = contact.get('fullname') || contact.get('nickname') || jid.split('@')[0];

        const confirmRequest = (/** @type {MouseEvent} */ ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            if (contact.get('requesting')) contact.authorize?.(); // приймаємо вхідний запит
            _converse.state.roster?.sendContactAddIQ?.({ jid, name })?.catch?.(() => {}); // зберігаємо в ростер
            contact.subscribe?.(); // підписка на присутність (взаємна)
            // Позначаємо як підтверджений локально → виходить із "Запити на контакт"
            // і потрапляє у "Негруповані" (навіть якщо XMPP-підписка ще ask='subscribe').
            contact.save?.({ confirmed: true, requesting: false });
            setTimeout(() => el.requestUpdate(), 50);
        };

        const rejectRequest = async (/** @type {MouseEvent} */ ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            try {
                if (contact.get('requesting')) contact.unauthorize?.(); // відхиляємо вхідний запит
                await contact.remove?.(true); // unsubscribe + видалення з ростера + знищення моделі
            } catch (e) {
                console.error('[Sonata] reject contact error', e);
            }
            setTimeout(() => el.requestUpdate(), 50);
        };

        const btnStyle =
            'flex:0 0 auto; display:inline-flex; align-items:center; justify-content:center;' +
            'width:30px; height:30px; padding:0; border-radius:50%; border:none; cursor:pointer; color:#fff;';
        return html`<li class="list-item sonata-request-item d-flex align-items-center" style="padding:6px 12px;gap:8px;flex-wrap:nowrap"><a href="#" class="d-flex align-items-center" style="text-decoration:none;color:inherit;flex:1 1 auto;min-width:0;overflow:hidden" @click="${(/** @type {MouseEvent} */ ev) => {
                        ev.preventDefault();
                        _converse.api.chats.open(jid, {}, true);
                    }}"><converse-avatar .model="${contact}" class="avatar" name="${name}" height="32" width="32" style="flex:0 0 auto"></converse-avatar><span class="contact-name" style="margin-left:8px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${name}</span> </a><button type="button" title="${__('Підтвердити')}" aria-label="${__('Підтвердити')}" style="${btnStyle}background:#1e9652" @click="${confirmRequest}"><converse-icon class="fa fa-check" size="1em" color="#fff"></converse-icon></button> <button type="button" title="${__('Відхилити')}" aria-label="${__('Відхилити')}" style="${btnStyle}background:#d9534f" @click="${rejectRequest}"><converse-icon class="fa fa-times" size="1em" color="#fff"></converse-icon></button></li>`;
    };

    const renderRosterGroup = (group) => {
        const rosterState = _converse.state.roster.state;
        const collapsed = rosterState.get('collapsed_groups') || [];
        const isCollapsed = collapsed.includes(group.name);

        console.log(
            `[Render Debug] Group: "${group.name}" | Contacts: ${group.contacts.length} | isCollapsed: ${isCollapsed}`,
        );

        return html`<div class="roster-group" data-group="${group.name}"><a href="#" class="list-toggle group-toggle controlbox-padded d-flex align-items-center" style="text-decoration:none;color:inherit;padding-top:5px;padding-bottom:5px;background:rgba(0,0,0,.03)" @click="${(ev) => {
                        ev.preventDefault();
                        const current = _converse.state.roster.state.get('collapsed_groups') || [];
                        console.log(`[UI Action] Toggling group: "${group.name}". Current collapsed:`, current);

                        let newCollapsed;
                        if (current.includes(group.name)) {
                            newCollapsed = current.filter((g) => g !== group.name);
                        } else {
                            newCollapsed = [...current, group.name];
                        }

                        _converse.state.roster.state.save({ 'collapsed_groups': newCollapsed });
                        console.log(`[UI Action] New collapsed state saved:`, newCollapsed);
                        el.requestUpdate();
                    }}"><converse-icon class="fa ${isCollapsed ? 'fa-caret-right' : 'fa-caret-down'}" size="1em" style="margin-right:8px"></converse-icon><span style="font-weight:700;font-size:.9em">${group.name} (${group.contacts.length})</span></a><ul class="items-list roster-group-contacts ${isCollapsed ? 'd-none' : ''}">${repeat(
                        group.contacts,
                        (c) => c.get('jid'),
                        (c) => (group.name === REQUESTS_LABEL ? renderRequestContact(c) : renderRosterContact(c)),
                    )}</ul></div>`;
    };

    const isMuted = (jid) => !!_converse.chatboxes.get(jid)?.get('muted');

    const toggleMute = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        const target = /** @type {HTMLElement} */ (ev.currentTarget);
        const jid = target.getAttribute('data-jid');
        const chatbox = _converse.chatboxes.get(jid);
        chatbox?.save('muted', !chatbox.get('muted'));
    };

    // No "bell-slash" asset exists in the icon set, so the muted/unmuted
    // states are distinguished by color (dim = muted) rather than shape;
    // the title tooltip carries the rest of the meaning.
    const renderMuteButton = (jid) => {
        const muted = isMuted(jid);
        return html`<a class="list-item-action toggle-mute" @click="${toggleMute}" data-jid="${jid}" title="${muted ? __('Увімкнути сповіщення') : __('Вимкнути сповіщення')}"><converse-icon class="fa fa-bell" size="1.3em" color="${muted ? 'var(--disabled-color)' : 'var(--secondary-color)'}"></converse-icon></a>`;
    };

    const isPinned = (jid) => !!_converse.chatboxes.get(jid)?.get('pinned');

    const togglePin = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        const target = /** @type {HTMLElement} */ (ev.currentTarget);
        const jid = target.getAttribute('data-jid');
        const chatbox = _converse.chatboxes.get(jid);
        chatbox?.save('pinned', !chatbox.get('pinned'));
    };

    const renderPinButton = (jid) => {
        const pinned = isPinned(jid);
        return html`<a class="list-item-action toggle-pin" @click="${togglePin}" data-jid="${jid}" title="${pinned ? __('Відкріпити чат') : __('Закріпити чат')}"><converse-icon class="fa ${pinned ? 'fa-bookmark' : 'fa-bookmark-empty'}" size="1.3em" color="${pinned ? 'var(--chat-color)' : 'var(--secondary-color)'}"></converse-icon></a>`;
    };

    const getUnreadCount = (jid) => {
        const chatbox = _converse.chatboxes.get(jid);
        if (!chatbox) return 0;

        const num = chatbox.get('num_unread') || 0;
        const num_gen = chatbox.get('num_unread_general') || 0;

        const final_num = Math.max(num, num_gen);

        if (final_num > 0) {
            return final_num < 100 ? final_num : '99+';
        }
        return 0;
    };

    // --- ФУНКЦІЇ РЕНДЕРУ (Оптимізовані) ---

    const renderRoom = (room) => {
        const jid = room.get('jid');
        const disp = typeof room.getDisplayName === 'function' ? room.getDisplayName() : '';
        const name =
            room.get('name') ||
            (disp && disp !== jid ? disp : '') ||
            _converse.chatboxes?.get(jid)?.get('name') ||
            _converse.bookmarks?.get(jid)?.get('name') ||
            jid.split('@')[0];
        const num_unread = getUnreadCount(jid);
        const lastTime = getLastMsgTime(jid);

        return html`<li class="list-item controlbox-padded available-chatroom d-flex flex-row ${isCurrentlyOpen(jid)
                    ? 'open'
                    : ''}" data-room-jid="${jid}"><div class="chat-item-content w-100" style="position:relative"><a class="list-item-link open-room available-room d-flex" href="#" data-room-jid="${jid}" @click="${(ev) => {
                            ev.preventDefault();
                            _converse.api.rooms.open(jid, { 'name': name }, true);
                        }}"><converse-avatar class="avatar avatar-muc" height="30" width="30" name="${name}"></converse-avatar><div class="chat-info flex-grow-1 ml-2 text-truncate"><div class="d-flex justify-content-between"><span class="chat-name font-weight-bold">${name}</span> <span class="chat-time text-muted small">${formatMsgTime(lastTime)}</span></div><div class="d-flex justify-content-between align-items-center"><div class="last-msg text-muted text-truncate small" style="max-width:85%">${getLastMsgText(jid)}</div>${num_unread && num_unread !== 0
                                    ? html`<span class="msgs-indicator badge badge-primary ml-1">${num_unread}</span>`
                                    : ''}</div></div></a></div>${renderPinButton(jid)} ${renderMuteButton(jid)} <a class="list-item-action close-room" @click="${(ev) => closeRoom(ev)}" data-room-jid="${jid}" data-room-name="${name}" title="Залишити групу"><converse-icon class="fa fa-sign-out-alt" size="1em"></converse-icon></a></li>`;
    };

    const renderContact = (contact, { showTime = true, showLastMsg = true } = {}) => {
        const jid = contact.get('jid');
        const num_unread = getUnreadCount(jid);
        // Only in the actual chat list (showTime implies that context), not
        // in "Мої категорії" contact/roster management.
        const showActions = showTime;

        return html`<li class="list-item d-flex flex-row controlbox-padded ${isCurrentlyOpen(jid) ? 'open' : ''}"><div class="chat-info flex-grow-1" style="position:relative"><div class="d-flex justify-content-between"><converse-roster-contact .model="${contact}"></converse-roster-contact>${showTime
                            ? html`<span class="chat-time text-muted small">${formatMsgTime(getLastMsgTime(jid))}</span>`
                            : nothing}</div>${showLastMsg
                        ? html`<div class="d-flex justify-content-between align-items-center"><div class="last-msg text-muted text-truncate small" style="max-width:85%">${getLastMsgText(jid)}</div>${num_unread && num_unread !== 0
                                  ? html`<span class="msgs-indicator badge badge-primary ml-1">${num_unread}</span>`
                                  : ''}</div>`
                        : nothing}</div>${showActions ? html`${renderPinButton(jid)}${renderMuteButton(jid)}` : nothing}</li>`;
    };
    const renderRoomSearch = (room) => {
        const jid = room.get('jid');
        const name = room.get('name') || jid.split('@')[0];

        return html`<li class="list-item controlbox-padded available-chatroom d-flex flex-row" data-room-jid="${jid}"><div class="chat-item-content w-100"><a class="list-item-link open-room available-room d-flex align-items-center" href="#" @click="${(ev) => {
                            ev.preventDefault();
                            _converse.api.rooms.open(jid, { 'name': name }, true);
                        }}"><converse-avatar class="avatar avatar-muc" height="30" width="30" name="${name}"></converse-avatar><div class="chat-info flex-grow-1 ml-2 text-truncate"><span class="chat-name font-weight-bold">${name}</span></div></a></div></li>`;
    };
    // Для таба "Мої категорії" — без часу, тексту і підписок
    const renderRosterContact = (contact) => renderContact(contact, { showTime: false, showLastMsg: false });

    // --- ДАНІ ТА ФІЛЬТРАЦІЯ ---
    const allRooms = (() => {
        const unique = new Map();

        // 1. Пріоритет - закладки (це "мої групи")
        (_converse.bookmarks?.models || []).forEach((b) => {
            unique.set(b.get('jid'), b);
        });

        // 2. Накладаємо активні чатбокси (у них актуальний статус повідомлень)
        (_converse.chatboxes?.models || [])
            .filter((m) => m.get('type') === 'chatroom' || !!m.get('muc_jid'))
            .forEach((c) => {
                unique.set(c.get('jid'), c);
            });

        return Array.from(unique.values());
    })();

    const allContacts = (() => {
        const myDomain = _converse.session.get('bare_jid')?.split('@')[1];
        // Keyed by local-part (e.g. "1100009"). When the same local-part appears
        // on multiple domains (stale roster entry after a domain migration), prefer
        // the entry from the current server domain; otherwise keep first seen.
        const byLocal = new Map();
        (_converse.state.roster?.models || []).forEach((c) => {
            const jid = c.get('jid');
            if (!jid) return;
            // MUC-кімнати не є контактами ростера — не показуємо їх у списку контактів.
            if (jid.includes('@conference.')) return;
            const [local, domain] = jid.split('@');
            if (!byLocal.has(local)) {
                byLocal.set(local, c);
            } else if (myDomain && domain === myDomain) {
                // Replace stale entry with the one from the current domain
                byLocal.set(local, c);
            }
        });
        return Array.from(byLocal.values());
    })();

    const activeChats = (() => {
        const seen = new Set();
        return [...allRooms, ...allContacts]
            .filter((i) => {
                const jid = i.get('jid');
                if (!jid || seen.has(jid)) return false;
                seen.add(jid);
                return hasMessages(jid);
            })
            .sort((a, b) => {
                // Pinned chats form their own group at the top, each still
                // ordered by recency within that group; unpinning drops a
                // chat straight back into the normal time-sorted order.
                const pinnedA = isPinned(a.get('jid'));
                const pinnedB = isPinned(b.get('jid'));
                if (pinnedA !== pinnedB) return pinnedA ? -1 : 1;
                const timeA = getLastMsgTime(a.get('jid'));
                const timeB = getLastMsgTime(b.get('jid'));
                return timeB - timeA;
            });
    })();

    return html`<div class="flyout box-flyout" style="${style || nothing}">${api.settings.get('view_mode') === 'overlayed'
                ? html`<converse-dragresize></converse-dragresize>`
                : nothing} ${el.model.get('connected')
                ? html`<converse-user-profile></converse-user-profile>${view_mode === 'new_chat'
                          ? html`<div class="controlbox-pane active-search" style="overflow-y:auto;height:calc(100% - 110px)">${renderAlphabeticalContacts()}</div>`
                          : html`${filter_text.length > 0
                                ? html`<div class="controlbox-pane active-search" style="overflow-y:auto"><ul class="items-list">${repeat(
                                              allRooms.filter((r) =>
                                                  (r.get('name') || '').toLowerCase().includes(filter_text),
                                              ),
                                              (r) => r.get('jid'),
                                              (r) => renderRoomSearch(r),
                                          )} ${repeat(
                                              allContacts.filter((c) =>
                                                  (c.get('fullname') || '').toLowerCase().includes(filter_text),
                                              ),
                                              (c) => c.get('jid'),
                                              (c) => renderContact(c, { showTime: false, showLastMsg: false }),
                                          )}</ul></div>`
                                : html`<ul class="nav nav-tabs controlbox-section custom-tabs"><li class="nav-item"><a class="nav-link ${active_tab === 'all' ? 'active' : ''}" href="#" @click="${() => {
                                                      el.model.set('active_tab', 'all');
                                                  }}">Усі чати</a></li><li class="nav-item"><a class="nav-link ${active_tab === 'groups' ? 'active' : ''}" href="#" @click="${() => {
                                                      el.model.set('active_tab', 'groups');
                                                  }}">Групи</a></li><li class="nav-item"><a class="nav-link ${active_tab === 'contacts' ? 'active' : ''}" href="#" @click="${() => {
                                                      el.model.set('active_tab', 'contacts');
                                                  }}">Мої категорії</a></li></ul><div class="controlbox-pane tab-content" style="overflow-y:auto;height:calc(100% - 160px);will-change:transform">${active_tab === 'all'
                                              ? html`<ul class="items-list active-chats">${repeat(
                                                            activeChats,
                                                            (i) => i.get('jid'),
                                                            (i) =>
                                                                i.get('type') === 'chatroom' ||
                                                                !!i.get('muc_jid') ||
                                                                (i.get('jid') || '').includes('@conference.')
                                                                    ? renderRoom(i)
                                                                    : renderContact(i),
                                                        )}</ul>${activeChats.length === 0
                                                        ? html`<div class="p-4 text-center text-mute">Немає листувань</div>`
                                                        : nothing}`
                                              : nothing} ${active_tab === 'groups'
                                              ? html`<ul class="items-list">${repeat(allRooms, (r) => r.get('jid'), renderRoom)}</ul>`
                                              : nothing} ${active_tab === 'contacts'
                                              ? html`<div class="roster-groups">${repeat(
                                                            getGroupedContacts(),
                                                            (g) => g.name,
                                                            renderRosterGroup,
                                                        )}</div>`
                                              : nothing}</div>`}`}`
                : whenNotConnected(el)}</div>`;
};
